// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2659":"d10aa72965dde8c4","3185":"160735dff3867d8b"}[chunkId] + ".css";
};